import module from 'finanzas/module.js'
import template from './template.html'
import { orderBy } from 'lodash'
import * as moment from 'moment'

export class FinancesServiciosagregadosComponent {
  fechaInicial
  fechaFinal
  proyectos
  data
  filtros = {
    q: '',
    moneda: '1',
    naturaleza: 'C',
    agrupacion: 'Captura_Usuario_Nombre',
  }
  catalogos = {
    proyectos: [],
  }
  promise

  constructor ($location, $q, $catalogos, FinanzasServiciosAgregados) {
    this.$location = $location
    this.$q = $q
    this.$catalogos = $catalogos
    this.FinanzasServiciosAgregados = FinanzasServiciosAgregados
  }

  $onChanges (changes) {
    if (changes.fechaInicial && !angular.isDate(this.fechaInicial)) {
      this.fechaInicial = new Date()
    }

    if (changes.fechaFinal && !angular.isDate(this.fechaFinal)) {
      this.fechaFinal = new Date()
    }

    if (changes.proyectos && !Array.isArray(this.proyectos)) {
      this.proyectos = []
    }
  }

  $onInit () {
    this.promise = this.$q.all([
      this.$catalogos.get('empresas')
        .then((data) => (this.catalogos.proyectos = orderBy(data, ['descripcion']))),
      this.proyectos.length
        ? this.FinanzasServiciosAgregados.get(this.proyectos, this.fechaInicial, this.fechaFinal)
        .then((response) => (this.data = orderBy(response.data, ['Fecha_Movimiento', 'Folio'], ['desc', 'desc'])))
        : undefined,
    ])
  }

  buscar () {
    if (!Array.isArray(this.proyectos) || !this.proyectos.length) {
      alert('Es necesario seleccionar al menos un proyecto.')
      return
    }

    this.$location.search({
      fecha_inicial: moment(this.fechaInicial).format('YYYY-MM-DD'),
      fecha_final: moment(this.fechaFinal).format('YYYY-MM-DD'),
      proyectos: this.proyectos,
    })
  }
}

module.component('financesServiciosagregados', {
  controller: FinancesServiciosagregadosComponent,
  template,
  bindings: {
    fechaInicial: '<',
    fechaFinal: '<',
    proyectos: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/serviciosagregados/component.js